import PropTypes from 'prop-types';
import React, { useContext, useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import countries from 'venuescanner-js/constants/countries.json';
import { inboxMobileView } from 'venuescanner-js/constants/thread';
import {
  default as userTypes,
  isHost,
  isOrganiser,
} from 'venuescanner-js/constants/user_type';
import { MemoizedDialogue } from 'venuescanner-js/react/components/Inbox/components/Chat/Dialogue';
import Search from 'venuescanner-js/react/components/Inbox/components/Chat/Search';
import { getStatus } from 'venuescanner-js/react/components/Inbox/components/Enquiry/EnquiryStatus/EnquiryStatus';
import Avatar from 'venuescanner-js/react/components/Inbox/components/Objects/Avatar';
import CtaNavBack from 'venuescanner-js/react/components/Inbox/components/Objects/Ctas/CtaNavBack';
import Loading from 'venuescanner-js/react/components/Inbox/components/Objects/Loading';
import { ViewContext } from 'venuescanner-js/react/components/Inbox/context/ViewContext';
import ChatReplyMessageInput from './ChatReplyMessageInput';
import CallButton from 'venuescanner-js/react/components/Inbox/components/Objects/CallButton';

const Chat = ({ thread, venue }) => {
  const {
    threadLoading,
    isMobileDevice,
    setActiveThreadStatus,
    setActiveCurrency,
    setActiveMobileView,
    activeUser,
    isSearchActive,
  } = useContext(ViewContext);
  const [showDataFor] = useState(
    isOrganiser(thread) ? `_${userTypes.host}` : `_${userTypes.organiser}`,
  );
  const searchParamStatus = new URLSearchParams(useLocation().search).get(
    'status',
  );

  // if we are on a mobile device and there is a search param status on first load then set the view to Enquiry (where all the views for status live)
  useEffect(() => {
    isMobileDevice &&
      searchParamStatus &&
      setActiveMobileView(inboxMobileView.ENQUIRY);
  }, []);

  useEffect(() => setActiveThreadStatus(getStatus(thread.status)), [thread]);

  useEffect(() => {
    if (isMobileDevice)
      setActiveCurrency(countries[thread?._venue?.country_code || 'GB']);
  }, [thread]);

  // TODO add class to message groups so that you can minimise the space between each message
  const imageUrl = thread[showDataFor]?.profile_photo
    ? thread[showDataFor]?.profile_photo !== '[object Object]'
      ? `https://cdn.venuescanner.com/${thread[showDataFor].profile_photo}`
      : null
    : null;
  // console.log({ thread })
  const venueNames = venue?.name.split(' ') || [];
  const firstName = thread[showDataFor]?.name || null;
  const lastName = thread[showDataFor]?.lastName || null;
  const hostName =
    firstName || lastName
      ? [firstName, lastName].filter(n => !!n).join(' ')
      : 'Host';
  const names = [];
  if (firstName) names.push(firstName);
  if (lastName) names.push(lastName);
  if (!names.length) {
    while (names.length < 2 && venueNames.length > 0) {
      names.push(venueNames.shift());
    }
  }

  return (
    <div className='chat inbox__section'>
      {threadLoading ? (
        <Loading />
      ) : (
        !threadLoading &&
        thread && (
          <>
            <div className='chat__header'>
              <div className='chat__header__row'>
                {isMobileDevice && (
                  <Link to='/inbox' className='chat__header__back-btn'>
                    <CtaNavBack />
                  </Link>
                )}
                {!isMobileDevice && (
                  <Avatar names={names} size={'medium'} imageUrl={imageUrl} />
                )}

                {((!isSearchActive && isMobileDevice) || !isMobileDevice) && (
                  <div className='chat__header__column'>
                    <span className='h5 chat__header__title'>
                      {thread.viewerRole === userTypes.organiser
                        ? `${hostName} at ${venue.name}`
                        : `${firstName || ''} ${lastName || ''}`}
                    </span>
                  </div>
                )}
              </div>
              <div className='chat__header__row chat__header__row--cta'>
                <div
                  className={`chat__header__ctas${
                    isSearchActive ? ' chat__header__ctas__active' : ''
                  }`}>
                  <Search />
                </div>

                {((isHost(thread) && thread._organiser?.phone) ||
                  isOrganiser(thread)) && (
                  <CallButton
                    thread={thread}
                    venue={venue}
                    activeUser={activeUser}
                    isMobileDevice={isMobileDevice}
                  />
                )}
              </div>
            </div>
            <MemoizedDialogue thread={thread} />
            <ChatReplyMessageInput isHost={isHost(thread)} />
          </>
        )
      )}
    </div>
  );
};

Chat.propTypes = {
  thread: PropTypes.object,
  venue: PropTypes.object,
};

export default Chat;
